import React, { useState } from 'react';
import Container from '@cloudscape-design/components/container';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import Button from '@cloudscape-design/components/button';
import Input from '@cloudscape-design/components/input';
import FormField from '@cloudscape-design/components/form-field';
import Alert from '@cloudscape-design/components/alert';
import ColumnLayout from '@cloudscape-design/components/column-layout';
import { api } from '../api/client';
import { useApi } from '../hooks/useApi';
import { ResponseViewer } from '../components/ResponseViewer';

export const LockPage: React.FC<{ app: string }> = ({ app }) => {
  const [lockName, setLockName] = useState('');
  const [actionName, setActionName] = useState('');
  const [exemptUser, setExemptUser] = useState('');
  const [exemptResource, setExemptResource] = useState('');
  const { loading, result, execute } = useApi();

  if (!app) return <Alert type="info">Select an application from the top bar.</Alert>;

  const create = () => execute(() => {
    const exemptions: Record<string, unknown[]>[] = [];
    const ex: Record<string, unknown[]> = {};
    if (exemptUser) ex.users = [{ type: 'PERSON', value: exemptUser }];
    if (exemptResource) ex.resources = [{ name: exemptResource, application: app }];
    if (Object.keys(ex).length) exemptions.push(ex);

    return api('POST', `/${encodeURIComponent(app)}/policy/lock`, {
      name: lockName,
      actionsWithExemptions: [{
        action: { name: actionName, application: app },
        exemptions: exemptions.length ? exemptions : undefined,
      }],
    });
  });

  const activate = () => execute(() => api('POST', `/${encodeURIComponent(app)}/lock/${encodeURIComponent(lockName)}/activate`));
  const deactivate = () => execute(() => api('POST', `/${encodeURIComponent(app)}/lock/${encodeURIComponent(lockName)}/deactivate`));

  return (
    <SpaceBetween size="l">
      <Header variant="h1">Lock Management</Header>

      <Container header={<Header variant="h2">Create Lock Policy</Header>}>
        <SpaceBetween size="m">
          <ColumnLayout columns={2}>
            <FormField label="Lock Name *">
              <Input value={lockName} onChange={({ detail }) => setLockName(detail.value)} placeholder="e.g. input_lock" />
            </FormField>
            <FormField label="Action to Lock *">
              <Input value={actionName} onChange={({ detail }) => setActionName(detail.value)} placeholder="e.g. edit" />
            </FormField>
            <FormField label="Exempt User (alias)">
              <Input value={exemptUser} onChange={({ detail }) => setExemptUser(detail.value)} placeholder="optional" />
            </FormField>
            <FormField label="Exempt Resource">
              <Input value={exemptResource} onChange={({ detail }) => setExemptResource(detail.value)} placeholder="optional" />
            </FormField>
          </ColumnLayout>
          <SpaceBetween direction="horizontal" size="s">
            <Button variant="primary" onClick={create} loading={loading} disabled={!lockName || !actionName}>
              Create Lock
            </Button>
            <Button onClick={activate} loading={loading} disabled={!lockName}>
              Activate
            </Button>
            <Button onClick={deactivate} loading={loading} disabled={!lockName}>
              Deactivate
            </Button>
          </SpaceBetween>
        </SpaceBetween>
      </Container>

      <ResponseViewer data={result?.data} error={result?.error} />
    </SpaceBetween>
  );
};
